import { ListboxOption, ListboxOptions } from "@headlessui/react";
import { FC, Fragment } from "react";
import { ImgAvatarRounded } from "../atoms/ImgAvatarRounded";

import { SpanIconCheckAvatar } from "../atoms/SpanIconCheckAvatar";

type select = {
  id: number;
  name: string;
  avatar: string;
};
export type ListSelectAvatarprops = {
  option: select[];
};

export const ListSelectAvatar: FC<ListSelectAvatarprops> = ({ option }) => {
  return (
    <Fragment>
      <ListboxOptions
        transition
        className="absolute z-50 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
      >
        {option?.map((person) => (
          <ListboxOption
            key={person.id}
            value={person}
            className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-500 data-[focus]:bg-primary-600 data-[focus]:text-white"
          >
            <div className="flex items-center">
              <ImgAvatarRounded src={person.avatar} />
              <span className="ml-3 block truncate text-gray-500">
                {person.name}
              </span>
            </div>
            <SpanIconCheckAvatar />
          </ListboxOption>
        ))}
      </ListboxOptions>
    </Fragment>
  );
};
